module.exports = __webpack_public_path__ + "img/8.我想成为的女人（洪晃）.40cabecb.jpg";